import { UserProfilePage as PlatformUserProfilePage } from '@jarvis/platform-ui';
import { useCallback } from 'react';
import { fetchProfile, fetchProfileActivity } from '../../api/auth';

export function UserProfilePage() {
  const loadProfile = useCallback(() => fetchProfile(), []);
  const loadActivity = useCallback(() => fetchProfileActivity(), []);
  return (
    <PlatformUserProfilePage fetchProfile={loadProfile} fetchProfileActivity={loadActivity} />
  );
}
